import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE,
    persistReducer,
    persistStore
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { combineReducers, configureStore } from '@reduxjs/toolkit';

import withSplitView from 'components/WithSplitView/state';

import useAccessToken from 'hooks/useAccessToken/state';
import useCurrentOrganization from 'hooks/useCurrentOrganization/state';
import useCurrentUser from 'hooks/useCurrentUser/state';
import useJohnDeere from 'hooks/useJohnDeere/state';
import useLogout from 'hooks/useLogout/state';
import useOAuth2 from 'hooks/useOAuth2/state';
import useOrganizations from 'hooks/useOrganizations/state';

import onboardingData from 'pages/OnboardingCurrentUserPage/hooks/useData/state';

const rootReducer = combineReducers({
    onboardingData,
    useAccessToken,
    useCurrentOrganization,
    useCurrentUser,
    useJohnDeere,
    useLogout,
    useOAuth2,
    useOrganizations,
    withSplitView
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['useJohnDeere', 'useOAuth2', 'withSplitView']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        }),
    reducer: persistedReducer
});

export const persistor = persistStore(store);
